/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  buildCacheKey,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";
const basePath = `${referenceService}/level-ppk`;

/** get Level PPK by activated */
type levelPPKParams = {
  activated: number;
};

export const getLevelPPK = async (params: levelPPKParams) => {
  const cacheKey = buildCacheKey("level-ppk", params);
  const cached = getCache(cacheKey);
  if (cached) return cached;

  try {
    const response = await api.get(`${basePath}`, { params });
    const data = response?.data?.return;
    if (data) setCache(cacheKey, data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Post Level PPK   */
type postLevelPPKParams = {
  kode: string;
  nama: string;
  activated: string;
};

export const postLevelPPK = async (params: postLevelPPKParams) => {
  const response = await api.post<any>(`${basePath}`, params);
  removeCacheByPrefix("level-ppk");
  return response?.data?.return;
};

/** Delete Level PPK  */
export const deleteLevelPPK = async (id: string) => {
  const response = await api.delete(`${basePath}/${id}`);
  removeCacheByPrefix("level-ppk");
  return response?.data?.return;
};
